import styles from './FaqBtn.module.css';
import { ReactComponent as ShowBtn } from '@Assets/svg/nav_link.svg';
import { ReactComponent as DeleteBtn } from '@Assets/svg/trash.svg';
import { ReactComponent as EditBtn } from '@Assets/svg/edit.svg';

interface FAQBtnProps {
	onClick: () => void;
	isOpen?: boolean;
	type: 'expand' | 'edit' | 'delete';
}

const FaqBtn = (props: FAQBtnProps) => {
	return (
		<>
			<button
				className={`${styles.btn_style} ${props.type === 'delete' ? styles.delete_btn : ''}`}
				onClick={props.onClick}
			>
				{props.type === 'expand' && <ShowBtn className={`${styles.svg_icon} ${props.isOpen ? styles.open : ''}`} />}
				{props.type === 'edit' && <EditBtn className={styles.svg_icon} />}
				{props.type === 'delete' && <DeleteBtn className={styles.svg_icon} />}
			</button>
		</>
	);
};

export default FaqBtn;
